import { render, staticRenderFns } from "./groups.vue?vue&type=template&id=45e55b52&scoped=true&"
import script from "./groups.vue?vue&type=script&lang=js&"
export * from "./groups.vue?vue&type=script&lang=js&"
import style0 from "./groups.vue?vue&type=style&index=0&id=45e55b52&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e55b52",
  null
  
)

export default component.exports